import { Box } from '@mui/material';
import styled from 'styled-components/macro';

export const DropZoneOuterStyled = styled(Box)`
  border: 1px dashed ${({ theme }): string => theme.colors.primary.variant6};
  border-radius: ${({ theme }): string => theme.radius.lg};
  padding: ${({ theme }): string => theme.spacing.xl};
  text-align: center;
  background-color: ${({ theme }): string =>
    theme.mode === 'dark' ? theme.colors.primary.variant4 : theme.colors.surface};
  transition: border-color 0.15s ease, background-color 0.15s ease;

  &[data-drag-active='true'] {
    border-color: ${({ theme }): string => theme.colors.primary.variant1};
    background-color: ${({ theme }): string =>
      theme.mode === 'dark' ? theme.colors.primary.variant5 : theme.colors.primary.variant3};
  }
`;
